import React, { useState } from "react";
import { SetupDataPageTemplate } from "../../../components/setup-pages/SetupDataPageTemplate";
import { Field, Form } from "react-jsonschema-form-validation";
import { pathRoot, schema } from "../Compensation";
import { setupData } from "../../../configs/routes";
import { Checkbox } from "../../../components/common/FormInputs";

//if page 1 is Yes or Not Yet
export const Page3 = ({ compensation, handleSave }) => {
	const options = [
		{
			label: "War Pension/Payment",
			value: 0,
		},
		{
			label: "State/Government",
			value: 1,
		},
		{
			label: "Civil",
			value: 2,
		},
	];

	const [whereFrom, setWhereFrom] = useState(compensation.whereFrom.slice());

	const toggleValue = (value) => {
		if (isChecked(value)) {
			setWhereFrom(whereFrom.filter((e) => e !== value));
		} else {
			const temp = [...whereFrom, value];
			setWhereFrom(temp);
		}
	};

	const isChecked = (value) => {
		return whereFrom.some((e) => e === value);
	};

	const getSelectElements = () => {
		const name = "whereFrom";

		const optionsElements = options.map((e) => {
			return (
				<>
					<Field
						type="select"
						key={`${name}${e.value}`}
						name={name}
						id={`${name}${e.value}`}
						className={"hidden"}
						checked={isChecked(e.value)}
						onClick={() => toggleValue(e.value)}
					/>
					<Checkbox
						htmlFor={`${name}${e.value}`}
						key={`${name}${e.value}Label`}
						label={e.label}
						checked={isChecked(e.value)}
					/>
				</>
			);
		});

		return optionsElements;
	};

	const nextTo = () => {
		if (isChecked(2)) {
			return `${pathRoot}/4`;
		}

		return setupData;
	};

	const onNext = () => {
		return new Promise((resolve, reject) => {
			compensation.whereFrom = whereFrom;
			compensation.whyNot = null;

			if (isChecked(2)) {
				resolve();
			} else {
				compensation.claimSuccess = null;
				compensation.totalCompensation = "";
				compensation.lawFirm = "";
				compensation.employer = "";
				handleSave(compensation).then(resolve).catch(reject);
			}
		});
	};

	const headerDetails = {
		title: "Compensation",
		currentPage: 3,
		pageCount: 4,
	};

	return (
		<SetupDataPageTemplate
			headerDetails={headerDetails}
			onClickNext={{ async: true, func: onNext }}
			nextTo={nextTo()}
			backTo={`${pathRoot}/1`}
			hideNext={whereFrom.length === 0}
			nextTextOverride={isChecked(2) ? null : "Finish"}
		>
			<Form schema={schema}>
				<p className={"text-lg sm:text-xl font-bold mb-6"}>
					If seeking/receiving compensation, where from?
				</p>
				<div>{getSelectElements()}</div>
			</Form>
		</SetupDataPageTemplate>
	);
};
